module.exports = __webpack_public_path__ + "img/ntk_nav_left_w.9847975f.svg";